import React from 'react';
import { Form, Grid } from 'semantic-ui-react';
import { Controller, useForm } from 'react-hook-form';
import { useDispatch } from 'react-redux';
import officeView from 'actions/office_view';
import { Notification, STATUS_TYPES } from 'dyl-components';

const ForceHangUp = ({ domain }) => {
    const { control, handleSubmit, formState: { isDirty, isValid }, reset } = useForm({
        defaultValues: {
            uuid: ''
        }
    });
    const dispatch = useDispatch();

    const onSubmit = async (data) => {
        try {
            await dispatch(officeView.hangup({ pbx_hostname: domain.pbx_domain, channel_uuid: data.uuid }));
            Notification.alert("Successfully hung up call", STATUS_TYPES.INFO)
            reset();
        } catch (error) {
            console.error(error);
            Notification.alert("Failed to hang up call", STATUS_TYPES.ERROR);
        }

    };

    return (
        <Form noValidate onSubmit={handleSubmit(onSubmit)}>
            <Grid verticalAlign='bottom'>
                <Grid.Row columns={2}>
                    <Grid.Column width={8}>
                        <Controller
                            name='uuid'
                            control={control}
                            render={({ field: { name, value, onChange } }) => (
                                <Form.Input
                                    name={name}
                                    value={value}
                                    onChange={(_, { value }) => { onChange({ target: { name, value } }) }}
                                    placeholder='Type UUID'
                                />
                            )}
                        />
                    </Grid.Column>
                    <Grid.Column width={8}>
                        <Form.Button color='primary' size="medium" type="button" disabled={!isDirty || !isValid} onClick={handleSubmit(onSubmit)}>
                            Hang Up
                        </Form.Button>
                    </Grid.Column>
                </Grid.Row>
            </Grid>
        </Form>
    );
};

export default ForceHangUp;
